export * from './src/promote-publisher-v1-item-items.meta.js';
